export default "__VITE_ASSET__ea8f260e__"